<fui-modal [maxHeight]="maxHeight" [maxWidth]="maxWidth" [state]="open">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()" [title]="formTitle">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <div class="content">
                <ng-template [ngTemplateOutletContext]="{'dataItem': dataItem, 'formGroup': formGroup}"
                             [ngTemplateOutlet]="formTemplateRef">
                </ng-template>
            </div>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()"></wbo-cancel-button>
                <wbo-ok-button (click)="save()" [title]="'wbo.common.button.done'"></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
